// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardContainer {
  display: grid;
  /* grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); */
  margin-top: 1.7rem;
  /* grid-gap: 100px; */
}

.d-inline {
  display: inline !important;
}

.center-text {
  text-align: center;
}

.main-color {
  color: #d0cdcb !important;
  font-weight: 600;
}

.labCard {
  /* background-color: #242424; */
  background: none;
  border: 1px solid #222322;
  text-align: center;
  border-radius: 8px;
  padding: 20px 0;
  margin-left: 2rem;
  margin-bottom: 2rem;
  border-radius: 9px;
  padding: 1rem;
  /* border: 2px solid gray; */
  width: 27vw;
  transition: 0.5s;
}
.labCard:hover {
  /* box-shadow: inset 5px 5px 8px rgb(49, 47, 47), inset -5px -5px 8px rgb(49, 47, 47); */
  /* transform: translateY(-20px); */
  transform: scale(1.05);
}
@media only screen and (max-width: 796px) {
  .labCard {
    width: 42vw;
    margin-left: 2rem;
    margin-bottom: 2rem;
  }
}
@media only screen and (max-width: 650px) {
  .labCard {
    margin-left: 0.5rem;
    margin-bottom: 0.5rem;
    width: 90vw;
  }
}
/* .card .img-wrapper {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
}
.card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
} */
`, "",{"version":3,"sources":["webpack://./src/modules/private/pages/labsCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iEAAiE;EACjE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,wFAAwF;EACxF,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;EACb;AACF;AACA;;;;;;;;;;;GAWG","sourcesContent":[".cardContainer {\r\n  display: grid;\r\n  /* grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); */\r\n  margin-top: 1.7rem;\r\n  /* grid-gap: 100px; */\r\n}\r\n\r\n.d-inline {\r\n  display: inline !important;\r\n}\r\n\r\n.center-text {\r\n  text-align: center;\r\n}\r\n\r\n.main-color {\r\n  color: #d0cdcb !important;\r\n  font-weight: 600;\r\n}\r\n\r\n.labCard {\r\n  /* background-color: #242424; */\r\n  background: none;\r\n  border: 1px solid #222322;\r\n  text-align: center;\r\n  border-radius: 8px;\r\n  padding: 20px 0;\r\n  margin-left: 2rem;\r\n  margin-bottom: 2rem;\r\n  border-radius: 9px;\r\n  padding: 1rem;\r\n  /* border: 2px solid gray; */\r\n  width: 27vw;\r\n  transition: 0.5s;\r\n}\r\n.labCard:hover {\r\n  /* box-shadow: inset 5px 5px 8px rgb(49, 47, 47), inset -5px -5px 8px rgb(49, 47, 47); */\r\n  /* transform: translateY(-20px); */\r\n  transform: scale(1.05);\r\n}\r\n@media only screen and (max-width: 796px) {\r\n  .labCard {\r\n    width: 42vw;\r\n    margin-left: 2rem;\r\n    margin-bottom: 2rem;\r\n  }\r\n}\r\n@media only screen and (max-width: 650px) {\r\n  .labCard {\r\n    margin-left: 0.5rem;\r\n    margin-bottom: 0.5rem;\r\n    width: 90vw;\r\n  }\r\n}\r\n/* .card .img-wrapper {\r\n  width: 120px;\r\n  height: 120px;\r\n  border-radius: 50%;\r\n  overflow: hidden;\r\n  margin: 0 auto;\r\n}\r\n.card img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
